import React, { useContext, useLayoutEffect, useState } from 'react'
import { AssetsContext } from '../../context'
import { Button } from '@components/Button'
import { Modal, ModalHeader, ModalSubHeader, ModalContent, ModalFooter } from '@components/Modal'

export const Unlink = () => {
  const { state, actions } = useContext(AssetsContext)
  const { asset, loading, modalScrollTop } = state
  const { confirmUnlink, back } = actions
  const temporarilyUnlinked = Boolean(asset.unlinked_at)
  const [mode, setMode] = useState(temporarilyUnlinked ? 'permanent' : 'temporary')
  useLayoutEffect(() => {
    if (modalScrollTop !== undefined) window.scrollTo(0, modalScrollTop)
  }, [modalScrollTop])
  return (
    <Modal open onClose={back} className="asset-confirmation-modal">
      <ModalHeader>{temporarilyUnlinked ? 'This asset is already temporarily unlinked' : 'Unlink this asset'}</ModalHeader>
      <ModalSubHeader>{asset.name}</ModalSubHeader>
      <ModalContent>
        {!temporarilyUnlinked && <fieldset className="unlink-mode-options">
          <legend>Choose how to unlink this asset</legend>
          <label><input type="radio" name="unlink-mode" value="temporary" checked={mode === 'temporary'} onChange={() => setMode('temporary')} disabled={loading} /> <strong>Temporarily</strong> — keep the contract so the next import can reconnect it.</label>
          <label><input type="radio" name="unlink-mode" value="permanent" checked={mode === 'permanent'} onChange={() => setMode('permanent')} disabled={loading} /> <strong>Permanently</strong> — remove the contract and keep this asset manual.</label>
        </fieldset>}
        {temporarilyUnlinked && <p>This asset is already temporarily unlinked. It will reconnect when its contract next appears in an import.</p>}
        {!temporarilyUnlinked && <p>Future imports will ignore a permanently unlinked asset. If the contract returns in the feed, it may appear as a separate imported asset.</p>}
        {loading && <p role="status">Unlinking asset...</p>}
      </ModalContent>
      <ModalFooter>
        <Button disabled={loading} secondary onClick={back}>Cancel</Button>
        <Button disabled={loading} primary onClick={() => confirmUnlink(mode)}>
          {temporarilyUnlinked ? 'Permanently unlink' : 'Unlink'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
